import React from 'react'
import numeral from 'numeral'
import PropTypes from 'prop-types'
import { LazyLoadImage } from 'react-lazy-load-image-component'

import {
  Icon as LibIcon,
  WalletIcon,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

import Icon from 'Pods/Shared/Icon/Icon'
import Loader from 'Pods/Shared/Loader'
import { SafeImage } from 'Utils/SafeImage'
import ResolveProductPricing from 'Utils/ResolveProductPricing'
import EmptyImage from 'images/no_image_medium.png'

import Tooltip from 'Pods/Shared/Tooltip'
import ItemPricing from './ItemPricing'

class ItemsListingItem extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      pricing: ResolveProductPricing(props),
      isChecked: false,
      displayGallery: false,
      galleryImageIndex: props.attributes.galleryImageUrls.length > 1 ? 1 : 0,
      isPreviewFailed: false,
      isPreviewLoaded: false,
      previewPosition: {
        top: 'initial',
        bottom: 'initial',
      },
    }

    this.el = React.createRef()

    this.nextGalleryImage = this.nextGalleryImage.bind(this)
    this.prevGalleryImage = this.prevGalleryImage.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ pricing: ResolveProductPricing(nextProps) })
  }

  componentDidMount() {
    this.props.onImpression()
  }

  nextGalleryImage() {
    if (this.props.attributes.galleryImageUrls.length > 1) {
      this.setState({ isPreviewLoaded: false })
    }

    if (this.state.galleryImageIndex === this.props.attributes.galleryImageUrls.length - 1) {
      this.setState({ displayGallery: true, galleryImageIndex: 0 })

      this.preloadImageByIndex(1)
      this.preloadImageByIndex(2)
    } else {
      this.setState({ displayGallery: true, galleryImageIndex: this.state.galleryImageIndex + 1 })

      this.preloadImageByIndex(this.state.galleryImageIndex + 2)
      this.preloadImageByIndex(this.state.galleryImageIndex + 3)
    }
  }

  prevGalleryImage() {
    if (this.props.attributes.galleryImageUrls.length > 1) {
      this.setState({ isPreviewLoaded: false })
    }

    if (this.state.galleryImageIndex === 0) {
      this.setState({ displayGallery: true, galleryImageIndex: this.props.attributes.galleryImageUrls.length - 1 })

      this.preloadImageByIndex(this.props.attributes.galleryImageUrls.length - 2)
      this.preloadImageByIndex(this.props.attributes.galleryImageUrls.length - 3)
    } else {
      this.setState({ displayGallery: true, galleryImageIndex: this.state.galleryImageIndex - 1 })

      this.preloadImageByIndex(this.state.galleryImageIndex - 2)
      this.preloadImageByIndex(this.state.galleryImageIndex - 3)
    }
  }

  preloadImageByIndex(index) {
    const imageUrl = this.props.attributes.galleryImageUrls[index]

    if (imageUrl) {
      const image = new Image()
      image.src = SafeImage(imageUrl, this.props.viewerIsAdult).largeUrl
    }

    return true
  }

  renderActions() {
    return (
      <div className="content-box__controls" onClick={this.props.onClick}>
        {
          this.props.isGalleryEnabled && this.props.displayCarouselButton && (
            <div className="content-box__control">
              <button className="action is-arrow-left carousel-trigger" onClick={this.prevGalleryImage}>
                <Icon type={['fas', 'chevron-left']} size="lg" notSpaced />
              </button>
            </div>
          )
        }
        {
          this.props.isGalleryEnabled && this.props.displayCarouselButton && (
            <div className="content-box__control" onClick={this.nextGalleryImage}>
              <button className="action is-arrow-right carousel-trigger">
                <Icon type={['fas', 'chevron-right']} size="lg" notSpaced />
              </button>
            </div>
          )
        }
        {
          this.props.displayAddToCartButton && this.state.pricing.price !== 0 && (
            <div className="content-box__control">
              <button
                className="action js-order"
                data-id={this.props.id}
                onClick={this.props.handleAddToCart}
              >
                <Icon type={['fas', 'shopping-cart']} size="lg" notSpaced />
              </button>
            </div>
          )
        }
        {
          this.props.withCheckbox && (
            <div className="content-box__control content-box__checkbox js-check-box" data-id={this.props.id}>
              <input
                type="checkbox"
                name={`item_${this.props.id}`}
                id={`item_${this.props.id}`}
                value={this.state.isChecked}
                className="checkbox"
                onChange={(el) => this.setState({ isChecked: el.currentTarget.checked })}
              />
              <label htmlFor={`item_${this.props.id}`} />
            </div>
          )
        }
      </div>
    )
  }

  renderRibbon() {
    if (this.props.withPremiumRibbon && this.state.pricing.price > 0) {
      return (
        <div className="discounts-wrapper">
          <div className="content-box__discount-badge discount-badge__premium">
            Premium
          </div>
        </div>
      )
    } if (this.state.pricing.ribbon) {
      if (this.state.pricing.ribbon === 'CLD') {
        return (
          <div className="discounts-wrapper">
            <Tooltip
              id={`tooltip-for-${this.props.id}`}
              className="content-box__discount-badge content-box__discount-badge--spaced"
              content={this.props.userSignedIn ? (
                `Cover ${numeral(this.state.pricing.discount).format('0%')} of price with CGTrader Points.
                  Save ${numeral(this.state.pricing.discountAmount).format('$0.00')}.`
              ) : (
                'Join CGTrader and buy this 3D Model up to 30% cheaper!'
              )}
            >
              <LibIcon color="light" notSpaced size="small" svgComponent={WalletIcon} />
            </Tooltip>
          </div>
        )
      } if (this.state.pricing.ribbon === 'saleOff') {
        const saleOffColorClassName = this.props.cart.saleOffColor !== 'red' ? ' discount-badge__green' : ''

        return (
          <div className="discounts-wrapper">
            <Tooltip
              id={`tooltip-for-${this.props.id}`}
              className={`content-box__discount-badge ${saleOffColorClassName}`}
              content={`${numeral(this.state.pricing.discountAmount).format('$0.00')} off`}
            >
              -{numeral(this.state.pricing.discount).format('0%')}
            </Tooltip>
          </div>
        )
      }
    }
  }

  galleryStyle() {
    if (this.el.current.parentNode.clientWidth / 2 <= this.el.current.offsetLeft) {
      return 'tooltip--align-right'
    }
    return 'tooltip--align-left'
  }

  setPreviewPosition() {
    const bounding = this.el.current.getBoundingClientRect()
    const viewportHeight = (window.innerHeight || document.documentElement.clientHeight)
    const navigationHeader = document.getElementById('navigation-header')
    const navigationHeight = navigationHeader ? navigationHeader.clientHeight : 0

    if (bounding.top >= navigationHeight && bounding.bottom <= viewportHeight) {
      this.setState({
        displayGallery: true,
        previewPosition: {
          top: '50%',
          bottom: 'initial',
          transform: 'translateY(-50%)',
        },
      })
    } else if (bounding.top < navigationHeight) {
      this.setState({
        displayGallery: true,
        previewPosition: {
          top: `${bounding.top > 0 ? navigationHeight + 10 - bounding.top : Math.abs(bounding.top) + navigationHeight + 10}px`,
          bottom: 'initial',
        },
      })
    } else if (bounding.bottom > viewportHeight) {
      this.setState({
        displayGallery: true,
        previewPosition: {
          top: 'initial',
          bottom: `${Math.abs(viewportHeight - bounding.bottom - 10)}px`,
        },
      })
    }
  }

  render() {
    const cardClasses = this.props.classNames || ''

    return (
      <div className={cardClasses} ref={this.el} style={{ position: 'relative' }}>
        <div
          className={`content-box content-box--new content-box--interactive previewable content-box--react-layout
            ${this.props.attributes.galleryImageUrls.length <= 1 ? ' content-box--with-single-image' : ''}
            ${this.state.isChecked ? ' is-checked' : ''}
            ${this.props.isCompact ? ' content-box--compact' : ''}
          `}
          onMouseOver={() => {
            this.setPreviewPosition()
          }}

          onMouseLeave={() => {
            this.setState({
              displayGallery: false,
              styles: {
                top: 'initial',
                bottom: 'initial',
              },
            })
          }}
        >
          <div className="content-box__content">
            {this.renderRibbon()}

            <ul className="content-box__badges-list">
              {this.props.attributes.vrBadges.map((vrBadge) => <li key={vrBadge}>{vrBadge}</li>)}
            </ul>

            <a
              href={this.props.attributes.url}
              title={`${this.props.attributes.isGameReady ? 'VR / AR / lowpoly ' : ''}${this.props.attributes.title} 3D Model`}
              className="content-box__link"
              onClick={this.props.onClick}
            >
              <figure className="content-box__image">
                {
                  typeof window !== 'undefined' ? (
                    <LazyLoadImage
                      alt={this.props.attributes.imageAlt}
                      src={SafeImage(this.props.attributes.primaryImage, this.props.viewerIsAdult).gridUrl}
                      visibleByDefault={this.props.imageVisibleByDefault}
                      afterLoad={this.props.onImpression}
                    />
                  ) : (
                    this.props.imageVisibleByDefault
                    && (
                    <img
                      alt={this.props.attributes.imageAlt}
                      src={SafeImage(this.props.attributes.primaryImage, this.props.viewerIsAdult).gridUrl}
                    />
                    )
                  )
                }
                <figcaption className="content-box__title">&nbsp;</figcaption>
              </figure>
            </a>
          </div>

          <ItemPricing titleIsHidden pricing={this.state.pricing} />

          {this.renderActions()}

          <div className="content-box__file-extensions">
            {this.props.attributes.shortFormatsList}
          </div>
        </div>

        {this.props.isGalleryEnabled && this.state.displayGallery && !this.props.isWithCarousel && (
          <div
            className={`content-box tooltip--item-preview tooltip--react-preview ${this.galleryStyle()}`}
            style={this.state.previewPosition}
          >
            <figure className="content-box__content">
              {!this.state.isPreviewLoaded && !this.state.isPreviewFailed && (
                <Loader className="loader--item-preview" />
              )}
              <img
                src={
                  SafeImage(
                    this.props.attributes.galleryImageUrls[this.state.galleryImageIndex],
                    this.props.viewerIsAdult
                  ).largeUrl
                }
                className={this.state.isPreviewLoaded ? '' : 'is-hidden'}
                alt=""
                onLoad={() => this.setState({ isPreviewLoaded: true })}
                onError={() => this.setState({ isPreviewFailed: true })}
              />
              {!this.state.isPreviewFailed && this.state.isPreviewLoaded && (
                <span className="item-preview__count text-extra-small text-white">
                  {`${this.state.galleryImageIndex + 1}/${this.props.attributes.galleryImageUrls.length}`}
                </span>
              )}
              {this.state.isPreviewFailed && !this.state.isPreviewLoaded && (
                <img
                  src={EmptyImage}
                  className={this.state.isPreviewFailed ? '' : 'is-hidden'}
                  alt=""
                />
              )}
              <figcaption className="content-box__title">
                {this.props.attributes.title}
                <ItemPricing titleIsHidden={false} pricing={this.state.pricing} />
                <div className="content-box__file-extensions">
                  {this.props.attributes.longFormatsList}
                </div>
              </figcaption>
            </figure>
          </div>
        )}
      </div>
    )
  }
}

ItemsListingItem.propTypes = {
  handleAddToCart: PropTypes.func.isRequired,
  attributes: PropTypes.shape({
    title: PropTypes.string.isRequired,
    imageAlt: PropTypes.string,
    authorUsername: PropTypes.string.isRequired,
    categoryTitle: PropTypes.string.isRequired,
    productType: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    saleOffDiscount: PropTypes.number,
    isCLDApplicable: PropTypes.bool.isRequired,
    isSaleOffApplicable: PropTypes.bool.isRequired,
    isGameReady: PropTypes.bool.isRequired,
    galleryImageUrls: PropTypes.arrayOf(PropTypes.shape({
      isAdultContent: PropTypes.bool.isRequired,
      largeUrl: PropTypes.string.isRequired,
    })).isRequired,
    vrBadges: PropTypes.arrayOf(PropTypes.string).isRequired,
    shortFormatsList: PropTypes.string.isRequired,
    longFormatsList: PropTypes.string.isRequired,
  }).isRequired,
  imageVisibleByDefault: PropTypes.bool,
  isGalleryEnabled: PropTypes.bool,
  isCompact: PropTypes.bool,
  viewerIsAdult: PropTypes.bool,
  userSignedIn: PropTypes.bool,
  cart: PropTypes.shape({
    value: PropTypes.number,
    creditsAvailable: PropTypes.number,
    applicableCldValue: PropTypes.number,
    saleOffDiscount: PropTypes.number,
    isSaleOff: PropTypes.bool,
    saleOffColor: PropTypes.string,
  }),
  displayAddToCartButton: PropTypes.bool,
  displayCarouselButton: PropTypes.bool,
  withCheckbox: PropTypes.bool,
  onImpression: PropTypes.func,
  isPreviewFailed: PropTypes.bool,
  isPreviewLoaded: PropTypes.bool,
  isPreviewVisible: PropTypes.bool,
  classNames: PropTypes.string,
  isWithCarousel: PropTypes.bool,
}

ItemsListingItem.defaultProps = {
  cart: {
    value: 0,
    creditsAvailable: 0,
    applicableCldValue: 0,
    isSaleOff: false,
    saleOffDiscount: 0,
    saleOffColor: 'red',
  },
  viewerIsAdult: false,
  userSignedIn: false,
  imageVisibleByDefault: true,
  isCompact: false,
  isGalleryEnabled: true,
  gaList: null,
  displayAddToCartButton: true,
  displayCarouselButton: true,
  withCheckbox: false,
  onImpression: () => {},
  isPreviewFailed: false,
  isPreviewLoaded: false,
  isPreviewVisible: false,
  classNames: '',
  isWithCarousel: false,
}

export default ItemsListingItem
